import React, { FC, useEffect, useMemo, useState } from 'react';
import { useGetActivityData } from '../api/queries/useGetActivityData';
import ActivityPopup from './ActivityItemPopup/ActivityPopup';
import { useIspmContext } from '../IspmContext';
import { AZURE_ENVIRONMENT } from '../constants';
import { IspmTopListsItem, IspmTopListsItemType } from './IspmTopListsItemType';
import { Icon, Icons } from '@silverfort/sf-components';

const IspmTopLists: FC = () => {
    const { domainFilter } = useIspmContext();
    const [popupOpen, setPopupOpen] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IspmTopListsItemType | null | undefined>(null);
    const { data } = useGetActivityData({
        domainName: domainFilter,
        entitySourceType: AZURE_ENVIRONMENT
    });

    useEffect(() => {
        setPopupOpen(() => Boolean(selectedItem));
    }, [selectedItem]);

    const selectItem = (item: IspmTopListsItem | null) => {
        const listItem = item ? list.find((listItem) => listItem.id === item) : null;

        setSelectedItem(listItem);
    };

    const list: Array<IspmTopListsItemType> = useMemo(
        () => [
            {
                counterColumnTitle: 'Requests',
                icon: Icons.Anomaly,
                id: IspmTopListsItem.TopActive,
                prefix: 'Active',
                resources: data?.topActiveResources ?? [],
                title: 'Top Active',
                users: data?.topActiveUsers ?? []
            },
            {
                counterColumnTitle: 'Denied authentications',
                icon: Icons.Block,
                id: IspmTopListsItem.TopDenied,
                prefix: 'Denied',
                resources: data?.topDeniedResources ?? [],
                title: 'Top Denied',
                users: data?.topDeniedUsers ?? []
            }
        ],
        [data?.topActiveResources, data?.topActiveUsers, data?.topDeniedResources, data?.topDeniedUsers]
    );
    return (
        <>
            {selectedItem && (
                <ActivityPopup
                    activityPrefix={selectedItem.prefix}
                    activityResources={selectedItem.resources}
                    activityUsers={selectedItem.users}
                    counterColumnTitle={selectedItem.counterColumnTitle}
                    onClose={() => selectItem(null)}
                    open={popupOpen}
                    title={selectedItem.title}
                />
            )}

            <div className="flex flex-col w-full divide-y divide-gray-100">
                {list.map((item) => (
                    <div
                        key={item.id}
                        className="flex justify-between items-center hover:cursor-pointer px-4 py-5 group"
                        onClick={() => selectItem(item.id)}>
                        <span className="flex gap-1 items-center">
                            <Icon
                                className="text-sf-gray-400 group-hover:text-sf-primary-500"
                                icon={item.icon}
                                size={16}
                            />

                            <span className="text-sf text-gray-500 group-hover:text-sf-primary-500">{item.title}</span>
                        </span>

                        <Icon
                            className="invisible text-sf-primary-500 group-hover:visible"
                            icon={Icons.Expand}
                            size={16}
                        />
                    </div>
                ))}
            </div>
        </>
    );
};

export default IspmTopLists;
